import React, { useContext } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import ErrorBoundary from './components/errorBoundary';
import Header from './components/header';
import Login from './views/login';
import Cuestionario from './views/cuestionario';
import { AuthProvider, AuthContext } from './context/AuthContext';

function App() {
  return (
    <Router>
      <AuthProvider>
        <ErrorBoundary>
          <>
            <React.Fragment>
              <Header />
              <Routes>
                <Route path="/" element ={<Login/>}/>
                <Route path="/formulari" element={<ProtectedCuestionario />}/>
              </Routes>
            </React.Fragment>
          </>
        </ErrorBoundary>
      </AuthProvider>
    </Router>
  );
}

//Validamos si se ha iniciado sesión
function ProtectedCuestionario() {
  const { isAuthenticated } = useContext(AuthContext);
  
  return isAuthenticated() ? <Cuestionario /> : <Navigate to="/" />;

  //return <Cuestionario />;
}

export default App;